import { styled } from "@mui/material"

export const BoxAlign = styled("div")({
  marginTop: "0.5rem",
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
})

export const TitlePage = styled("h1")({
  color: "#353535",
  fontSize: "1.6rem",
  fontFamily: "Inter",
  fontWeight: 600,
  lineHeight: "1.7rem",
  letterSpacing: "0.01em",
})

export const Configs = styled("div")({
  border: "0.5px solid #757575",
  color: "#757575",
  fontSize: "1rem",
})

export const Container = styled("div")({
  display: "flex",
  height: "60vh",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
})

export const TextWarning = styled("span")({
  fontSize: "10rem",
  fontFamily: "Inter",
  fontWeight: 500,
  letterSpacing: "0.01em",
  color: "#FF8C42",
})

export const TextHelper = styled("p")({
  color: "#000000",
  fontSize: "1.5rem",
  fontFamily: "Roboto",
  fontWeight: 500,
  lineHeight: "1.2rem",
  letterSpacing: "0.01em",
})
